import type { ChangeEvent } from 'react'
import { forwardRef, useEffect, useState } from 'react'
import { Box, Checkbox } from '@mantine/core'

import type { CheckboxInputProps } from '@/components/CheckboxInput/CheckboxInput.types'

import classes from './CheckboxInput.module.css'

export const CheckboxInput = forwardRef<HTMLInputElement, CheckboxInputProps>(
  ({ containerProps, onChange, value, ...props }, ref) => {
    const [localValue, setLocalValue] = useState<boolean>(value || false)

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
      onChange?.(event)
      setLocalValue(event.currentTarget.checked)
    }

    useEffect(() => {
      setLocalValue(value || false)
    }, [value])

    return (
      <Box {...containerProps}>
        <Checkbox
          {...props}
          ref={ref}
          checked={localValue}
          classNames={{
            description: classes.description,
            error: classes.errorText,
            input: classes.checkbox,
            label: classes.label,
          }}
          onChange={handleChange}
        />
      </Box>
    )
  },
)
